/**
 * AP · Slot cart attribution — gắn properties[_slot] vào mọi add-to-cart để
 * đo performance từng vị trí upsell (Phase 8 đọc từ order line properties).
 *
 * Cơ chế: capture-phase submit listener trên document. Form add-to-cart nào
 * (action chứa /cart/add) cũng được chèn hidden input properties[_slot] với
 * giá trị lấy từ container [data-slot] gần nhất; PDP main form không nằm
 * trong slot nào → mặc định "pdp-atc". Horizon submit bằng fetch(FormData(form))
 * nên hidden input đi theo cả AJAX add. Không phụ thuộc thư viện ngoài.
 */
(function () {
  'use strict';

  // các section native không tự mang data-slot → map theo section id trong template JSON
  var SECTION_SLOT_MAP = {
    product_recommendations: 'pdp-complementary',
    related_bogo_picker: 'pdp-related',
    best_sellers: 'home-bestsellers',
    bogo_grid: 'home-bogo-grid',
    nf_bestsellers: '404-bestsellers',
  };

  function tagSections() {
    document.querySelectorAll('.shopify-section').forEach(function (sec) {
      if (sec.hasAttribute('data-slot')) return;
      var id = sec.id || '';
      for (var key in SECTION_SLOT_MAP) {
        if (id.indexOf(key) !== -1) { sec.setAttribute('data-slot', SECTION_SLOT_MAP[key]); return; }
      }
    });
  }

  function slotFor(el) {
    var holder = el.closest('[data-slot]');
    if (holder) return holder.getAttribute('data-slot');
    // main PDP form ngoài mọi slot
    if (document.body.classList.contains('template-product') || location.pathname.indexOf('/products/') !== -1) {
      return 'pdp-atc';
    }
    return null;
  }

  function ensureInput(form, slot) {
    var input = form.querySelector('input[name="properties[_slot]"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_slot]';
      form.appendChild(input);
    }
    input.value = slot;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    var slot = slotFor(form);
    if (slot) ensureInput(form, slot);
  }, true);
  // 2026-08-17 (QA): Horizon fetch FormData TRƯỚC submit-listener → set input ngay lúc pointerdown/click
  // trên nút submit (input tĩnh đã có trong buy-buttons; đây ghi đè theo slot container gần nhất)
  document.addEventListener('pointerdown', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('button[type="submit"], button[name="add"]') : null;
    if (!btn) return;
    var form = btn.form || btn.closest('form');
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    var slot = slotFor(form);
    if (slot) ensureInput(form, slot);
  }, true);

  // fallback cho add bằng nút không nằm trong form (Horizon quick-add modal
  // clone form vào modal — modal nằm ngoài slot container → nhớ slot lúc click)
  var lastClickedSlot = null;
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-slot] a, [data-slot] button') : null;
    if (t) lastClickedSlot = slotFor(t);
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    if (!form.querySelector('input[name="properties[_slot]"]') && lastClickedSlot) {
      ensureInput(form, lastClickedSlot);
    }
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tagSections);
  else tagSections();
  document.addEventListener('shopify:section:load', tagSections);

  /**
   * Đổi quantity một line mà GIỮ NGUYÊN properties (kể cả _slot).
   * Mọi code AP muốn gọi cart/change.js phải đi qua helper này —
   * gọi change trần với properties thiếu sẽ xoá mất attribution.
   */
  window.apCartChange = function (lineKey, quantity) {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = cart.items.find(function (i) { return i.key === lineKey; });
        var body = { id: lineKey, quantity: quantity };
        if (line && line.properties) body.properties = line.properties;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        }).then(function (r) { return r.json(); });
      });
  };
})();
